import './CasosDeExito.css';

const CasosDeExito = () => {
  return (
    <div className="casosdeexito-container">
      <h2 className="titulo">Lo que dicen nuestros clientes</h2>

      {/* Imagen de fondo */}
      <div className="contacto-background">
        <img 
          src="/images/casosexitobackground.jpg" 
          alt="Imagen de fondo de contacto" 
          aria-hidden="true" 
        />
      </div>
      <div className="contacto-overlay"></div>

      {/* Tarjetas de testimonios */}
      <div className="tarjetas-container">
        {/* Tarjeta 1 - LogiFast */}
        <div className="tarjeta">
          <div className="tarjeta-img">
            <img src="/images/logifast.png" alt="LogiFast" />
          </div>
          <div className="tarjeta-contenido">
            <h3>LogiFast</h3>
            <p>
              "Gracias a las soluciones personalizadas de Sage 200 que desarrollaron para nuestra empresa, hemos logrado automatizar el 90% de nuestros procesos de inventario. Esto no solo ha reducido errores, sino que también ha mejorado nuestra eficiencia operativa. ¡Un gran equipo de expertos!"
              <br />
              <i>Ana López, Directora de Operaciones.</i>
            </p>
          </div>
        </div>

        {/* Tarjeta 2 - FinExpert Consultores */}
        <div className="tarjeta">
          <div className="tarjeta-img">
            <img src="/images/finexpert.png" alt="FinExpert Consultores" />
          </div>
          <div className="tarjeta-contenido">
            <h3>FinExpert Consultores</h3>
            <p>
              "El equipo entendió nuestras necesidades desde el principio y creó aplicaciones complementarias para Sage 200 que simplificaron la gestión de informes personalizados para nuestros clientes. Hemos ahorrado más de 15 horas a la semana en tareas manuales."
              <br />
              <i>Carlos Fernández, Gerente General.</i>
            </p>
          </div>
        </div>

        {/* Tarjeta 3 - ElectroShop */}
        <div className="tarjeta">
          <div className="tarjeta-img">
            <img src="/images/electroshop.png" alt="ElectroShop" />
          </div>
          <div className="tarjeta-contenido">
            <h3>ElectroShop</h3>
            <p>
              "Las integraciones con Sage 200 desarrolladas nos permitieron conectar nuestro sistema de ventas online directamente con nuestro sistema de facturación. Ahora todo fluye sin problemas, y nuestros tiempos de procesamiento se han reducido a la mitad."
              <br />
              <i>Laura Martín, Responsable de Ventas.</i>
            </p>
          </div>
        </div>

        {/* Tarjeta 4 - InduParts */}
        <div className="tarjeta">
          <div className="tarjeta-img">
            <img src="/images/InduPartsLogo.png" alt="InduParts" />
          </div>
          <div className="tarjeta-contenido">
            <h3>InduParts</h3>
            <p>
              "El equipo no solo implementó Sage 200 perfectamente, sino que además crearon una solución a medida para gestionar nuestros pedidos de producción en tiempo real. Estamos impresionados por su profesionalidad y compromiso."
              <br />
              <i>Javier Ruiz, Jefe de Producción.</i>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CasosDeExito;
